import angular from "angular";

angular.module('ui-common', []);
